// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fc735a97","980":"556c9455"}[chunkId] + ".chunk.js";
};